import React from 'react';
import "./Modal.css";

const MyModal = ({img, txt, setexitModal,action}) => {

    const DoAvtion = () => {
        action()
        setexitModal(false)
    }
    //برای هندل کردن ارور عکس ها
    const addDefaultSrc = (ev) => {
        ev.target.src = "/images/placeholder.jpg";
    };


    return (  
        <>
            <div className="RoundImgPartModel">
                <img onError={addDefaultSrc} alt='آیکون مودال' src={img} style={{width:"60%"}}  />
            </div>
            <div className="TextPartModal">
                <div style={{width:"100%", height:"100%", backgroundColor:"#fff",textAlign:"center", display:"flex", flexDirection:"column", alignItems:"center"}}>
                    <p style={{margin:"0",fontWeight:'bold'}}>
                        {txt}
                    </p>
                </div>
            </div>

            <div className="buttonRowBottom" >
                <div  onClick={() => setexitModal(false)} 
                style={{
                        width: '50%',
                        height: '100%',
                        backgroundColor: "green",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#fff',
              
                }}>
                    <p style={{margin:"0"}}>
                        خیر
                    </p>
                </div>
                <div onClick={() => DoAvtion()}
                style={{
                    width: '50%',
                    height: '100%',
                    backgroundColor: "red",
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#fff',
              
                }}>
                    <p style={{margin:"0"}}>
                        بله
                    </p>
                </div>
            </div>
        </>
                
    );
}
 
export default MyModal;